import { Action, combineReducers } from "redux";
import { ThunkAction, ThunkDispatch } from "redux-thunk";
import * as RR from "react-redux";
import auth from "features/auth/reducers/auth";
import access from "features/panelManagement/accessManagement/reducers/access";
import logs from "features/panelManagement/logging/reducers/logs";
import backups from "features/panelManagement/backups/reducers/backups";
import table from "features/shared/reducers/table";
import editor from "features/shared/reducers/editor";
import tags from "features/tagEdit/reducers/tags";
import products from "features/product/reducers/products";
import subProducts from "features/product/reducers/subproducts";
import articles from "features/article/reducers/articles";

const rootReducer = combineReducers({
    auth,
    access,
    logs,
    backups,
    table,
    editor,
    tags,
    products,
    subProducts,
    articles,
});

export type RootState = ReturnType<typeof rootReducer>;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;
export type AppDispatch = ThunkDispatch<RootState, unknown, Action<string>>;

export const useSelector: RR.TypedUseSelectorHook<RootState> = RR.useSelector;
export const useDispatch = (): AppDispatch => RR.useDispatch<AppDispatch>();

export default rootReducer;
